import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { Button, Header, Label, Segment } from "semantic-ui-react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import Swal from "sweetalert2";

import "../../components/pages/homeLoggedIn.css";
import * as Yup from 'yup';
import { MySelectInput, MySelectInputControl } from "../../app/common/form/MySelectInput";
import { listRoles, listRolesFormValues } from "../../app/models/Roles";
import SGTEntidadStore from '../../app/stores/SGTEntidadesStore';

type OptionType = {
    value: string;
    text: string;
};

export default observer(function AsignarRolUser() {

    let contador = 0;
    let roles: any = [];
    let entidades: any = [];

    const SuccesModal = () => {
        Swal.fire({
            position: "center",
            icon: "success",
            title: "Información actualizada",
            text: 'Su ficha personal se ha actualizado satisfactoriamente.',
            showConfirmButton: false,
            timer: 3500,
        });
    };

    const { CCTOperacionStore, RolesStore: { allRoles, RolByCodigo, assingRolToUser } } = useStore();
    const { SGTEntidadStore: { SGTEntidadByName, loadSGTEntidades } } = useStore();
    const [showfield, setShowfield] = useState();
    
    useEffect(() => {
        allRoles()
    }, [allRoles])
    
    useEffect(() => {
        loadSGTEntidades()
    }, [loadSGTEntidades])
    
    const { loading, personaDPI, inputPersona, dpiByCodigo } = CCTOperacionStore;
    const [listRoles, setCCTipoDeDocumento] = useState<listRolesFormValues>(new listRolesFormValues());

    const [selectedOption1, setSelectedOption1] = useState<OptionType | null>(null);
    const [selectedOption2, setSelectedOption2] = useState<OptionType | null>(null);
    
    const validationSchema = Yup.object({})

    function buscrPersona() {
        const valorInput = (document.getElementById("name") as HTMLInputElement).value;
        if (valorInput.length == 13) {
            personaDPI(valorInput)
        }
    }

    if (RolByCodigo.length > 0) {
        RolByCodigo.map((cuenta) => {
            const c = { text: cuenta.name.toString(), value: cuenta.id.toString() }
            roles.push(c)
            contador = contador + 1
        })
    }

    if (SGTEntidadByName.length > 0) {
        SGTEntidadByName.map((entidad) => {
            const en = { text: entidad.entidad, value: entidad.idEntidad.toString() }
            entidades.push(en)
        })
    }

    function handleFormSubmit(itemFormik: any) {
        var idPersona = "";
        dpiByCodigo.map((item) => {
            idPersona = item.id
            assingRolToUser(selectedOption1?.value, idPersona, itemFormik["Entidad"]);
        })
    }

    const handleOption1Change = (selectedOption: OptionType | null) => {
        setSelectedOption1(selectedOption);
        setSelectedOption2(null);
    };

    const options1: OptionType[] = roles;
    const options2: OptionType[] = entidades;

    //    if (CCTOperacionStore.loadingInitial) return <LoadingComponent content='Cargando...' />

    return (
        <div className="pagina_formulario">
            <Segment className="contenedor_formulario">
                <Formik validationSchema={validationSchema}
                    enableReinitialize
                    initialValues={{ name: '', rol: '', Entidad: '' }}
                    onSubmit={(values, { resetForm }) => {
                        handleFormSubmit(values)
                        const valorInput = (document.getElementById("name") as HTMLInputElement);
                        valorInput.value = ""
                        CCTOperacionStore.DPIRegistry.clear()
                        resetForm({
                            values: {
                                name: "",
                                rol: "",
                                Entidad: ""
                            }
                        })
                    }}>
                    {({ handleSubmit, isValid, isSubmitting, dirty }) => (
                        <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                            <Header size='large' content='Asignar Roles' style={{ color: "#538cbe", fontFamily: "Gotham" }} />
                            <br></br>
                            <div style={{ marginBottom: "10px" }} >
                                <Header size="small" content="DPI" />
                                <input name='name' id="name" maxLength={13} minLength={13} onChange={buscrPersona}></input>
                                {CCTOperacionStore.dpiByCodigo.map((item) => {
                                    if (item.id) {
                                        return <Label basic color="blue">{item.nombre}</Label>
                                    } else {
                                        return <Label basic color='red'>No se encuentra registrado</Label>
                                    }
                                })}
                            </div>
                            <div>
                                <Header size="small" content="Rol" />

                                <select
  id="rol"
  name="rol"
  value={selectedOption1?.value ? selectedOption1.value.toString() : ""} // Corregir aquí
  onChange={(e) =>
    handleOption1Change(
      options1.find((option: any) => option.value === e.target.value) || null
    )
  }
>
  <option value="">Seleccione una opción</option>
  {options1.map((option: any) => (
    <option key={option.value} value={option.value.toString()}> {/* Corregir aquí */}
      {option.text}
    </option>
  ))}
</select>

{selectedOption1?.text === "Institucional" && (

    <MySelectInputControl
      label="Perfil institucional"
      id="Entidad"
      name="Entidad"
      placeholder="- Selecciona una opción -"
      options={entidades}
    />
  
)}

                            
                           </div>
                            <br></br>
                            <div>
                                <Button
                                    loading={loading}
                                    type='submit'
                                    content='Asignar'
                                    onClick={SuccesModal}
                                    style={{ backgroundColor: "#15b3e8", color: "white" }} />
                            </div>
                        </Form>
                    )}
                </Formik>
            </Segment>
        </div>
    )
})

